import React, { useState } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import styles from './Checkbox.module.scss'

const noop = () => false

const Checkbox = React.forwardRef(
  (
    {
      id,
      name,
      className,
      toggle,
      pill,
      children,
      checked,
      onChange = noop,
      onBlur,
      onFocus,
      disabled,
      ...restProps
    },
    ref
  ) => {
    const [focused, setFocused] = useState(false)

    return (
      <div
        className={classnames(
          styles.root,
          toggle && styles.checkBoxRoot,
          pill && styles.checkBoxPill,
          checked && styles.checked,
          focused && styles.focused,
          disabled && styles.disabled,
          className
        )}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.target.checked = !e.target.checked
            onChange(e)
          }
        }}
      >
        {toggle && <div className={styles.circle} />}
        <input
          id={id}
          ref={ref}
          name={name}
          type="checkbox"
          className={classnames(
            styles.inputRoot,
            toggle && styles.hide,
            pill && styles.hide
          )}
          checked={checked}
          onChange={onChange}
          onFocus={(e) => {
            setFocused(true)
            if (onFocus) onFocus(e)
          }}
          onBlur={(e) => {
            setFocused(false)
            if (onBlur) onBlur(e)
          }}
          onClick={(e) => e.target.blur()}
          disabled={disabled}
          {...restProps}
        />
        {pill && children}
      </div>
    )
  }
)

Checkbox.defaultProps = {
  checked: false,
}

Checkbox.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  toggle: PropTypes.bool,
  pill: PropTypes.bool,
  children: PropTypes.any,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default Checkbox
